
import React, { useState, useContext } from 'react';
import './AddOn.css';
import { assets } from '../assets/assets';
import { StoreContext } from '../context/StoreContext';

export default function AddOn({ setShowPopUp }) {
  const [currState, setCurrState] = useState("Details");
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [disabledButtons, setDisabledButtons] = useState({
    button1: false,
    button2: false,
    button3: false,
    button4: false,
    button5: false,
    button6: false,
  });

  const { addToCart } = useContext(StoreContext);

  const handleButtonClick = (price, size) => {
    if (size === '22oz') {
      // setSelectedPrice(price => price + 10);
      setBasePrice(49); // Set base price for 22oz
    } else {
      setSelectedPrice(price);
      setBasePrice(39); // Set base price for 16oz
    }
  };

  const handleAddToCart = (itemId) => {
    if (selectedPrice !== 0) {
      const size = basePrice === 39 ? '16oz' : '22oz';
      const addOns = Object.keys(disabledButtons).filter(button => disabledButtons[button]);
      addToCart(itemId, size, addOns, selectedPrice);
      setShowPopUp(false);
    }
  };

  return (
    <div className="popup">
      <form className="addson-popup-container" onSubmit={(e) => e.preventDefault()}>
        <div className="popup-title">
          <h2>{currState}</h2>
          <img onClick={() => setShowPopUp(false)} src={assets.cross_icon} alt="Close" />
        </div>
        <div className="addson-popup-input">
          <button type="button" onClick={() => handleButtonClick(39, '16oz')}>16oz</button>
          <button type="button" onClick={() => handleButtonClick(49, '22oz')}>22oz</button>
        </div>
        <div className="atc">
          <button type="button" onClick={() => handleAddToCart('P' + selectedPrice)}>Add to Cart</button>
        </div>
      </form>
    </div>
  );
}
